import React from 'react';
import styled from '@emotion/styled';
import mq from "../../Styles/breakpoints";
import { fontSize } from "../../Styles/text";
import { css } from '@emotion/core';
import { asset } from './helpers';

function Hero(props) {
  const HeroBlock = styled.div`
    position: relative;
    background: url("${asset('ways-to-watch/victoria-hero.jpg')}");
    background-size: cover;
    background-position-x: 50%;
    background-position-y: center;
    max-height: 800px;
    height: 55vh;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-top: -3vw;
    padding: 2rem;
    font-size: ${ fontSize(4) };


      ${mq.medium(`
        background-position-x: center;
        background-position-y: 10% !important;
      `)};

      ${mq.large(`
        background-position-x: center;
        background-position-y: top;
      `)};

      ${mq.xlarge(`
        background-position-x: center;
        background-position-y: 30% !important;
      `)};
  `;

  const Spacer = styled.div`
    color: white;
    margin-top: 0vh;
    width: 100%;
    padding: 40px;
   
    ${mq.large(`
      margin-top: 8vh;
    `)}; 
  `;

  const H1 = styled.h1`
    color:white;
    line-height:1.1;
    margin-bottom: 2.5em;
    font-size: 1.6em;
    
    ${mq.large(`
      font-size: 2em;
      max-width: 540px;
    `)}; 
  `;

  const videoAppLogoStyles = css`
      width: 154px; 
  `;

  return(
    <HeroBlock>

      <div css={css`z-index: 2;`}>
        <Spacer />
        <H1>Watch your favorite shows on the PBS App</H1>
      </div>
    </HeroBlock>
  );
}

export default Hero;
